import { RedAd } from 'models/RedAd';
import { NO_ELEMENT } from 'utils';
import styles from './splash.scss';
import cn from 'classnames';
import { ThemeMeta } from 'models/SectionBlock';

interface SplashProps extends Pick<RedAd, 'splash' | 'splashHeader'>, ThemeMeta {
  panorama?: boolean;
  color?: string;
  size: 'large' | 'small';
  className?: string;
}

const showSplash = (splash = ''): splash is string => splash.length >= 1;

export const AdSplash = ({
  size = 'large',
  splash,
  splashHeader,
  className,
  panorama,
  onSurface
}: SplashProps) =>
  showSplash(splash) ? (
    <div
      style={{ backgroundColor: onSurface }}
      className={cn(
        styles.splash,
        {
          [styles.small]: size === 'small',
          [styles.large]: size === 'large',
          [styles.splashPanoramaBackground]: panorama
        },
        className
      )}
    >
      {splashHeader && <span className={styles.splashHeader}>{splashHeader}</span>}
      <span className={styles.splashText}>{splash}</span>
    </div>
  ) : (
    NO_ELEMENT
  );
